/**
 * Durum sözlüğünün metinleri (08 §5.7 A–E). Anahtarlar kararlı ve ASCII'dir; görünen kod (`code`) ve etiket
 * (`label`) buradadır, çünkü kodlar tenant bazında yeniden adlandırılabilir. Renk ve ikon
 * `@ticarishift/ui` durum sözlüğündedir (`dictionary.ts`).
 */
export const status = {
  day: {
    N: { code: 'N', label: 'Normal çalışma' },
    HT: { code: 'HT', label: 'Hafta tatili' },
    HTC: { code: 'HTÇ', label: 'Hafta tatilinde çalışma' },
    RT: { code: 'RT', label: 'Resmi tatil' },
    AY: { code: 'AY', label: 'Arife ya da 28 Ekim yarım gün' },
    RTC: { code: 'RTÇ', label: 'Resmi tatilde çalışma' },
    ST: { code: 'ŞT', label: 'Şirket tatili' },
    YI: { code: 'Yİ', label: 'Yıllık izin' },
    MI: { code: 'Mİ', label: 'Mazeret izni' },
    UI: { code: 'Üİ', label: 'Ücretsiz izin' },
    R: { code: 'R', label: 'Rapor' },
    D: { code: 'D', label: 'Devamsız' },
    GO: { code: 'GÖ', label: 'Görevli' },
    PC: { code: 'PÇ', label: 'Plansız çalışma' },
    X: { code: 'X', label: 'Planlı çalışma yok' },
    CX: { code: 'ÇX', label: 'Bitişi eksik' },
  },
  bucket: {
    FM: { code: 'FM', label: 'Fazla çalışma (FM, %50)' },
    FSC: { code: 'FSÇ', label: 'Fazla sürelerle çalışma (FSÇ, %25)' },
    GC: { code: 'GÇ', label: 'Gece çalışması' },
    G11: { code: 'G11', label: 'Günlük 11 saat aşımı' },
    IB: { code: 'İB', label: 'İcap bekleme' },
    UNDER: { code: 'Eksik', label: 'Eksik süre' },
  },
  flag: {
    late: { code: 'G⁺', label: 'Geç başladı' },
    leftEarly: { code: 'EÇ', label: 'Erken bitirdi' },
    earlyArrival: { code: 'EG', label: 'Erken geldi, onay bekliyor' },
    pendingDecision: { code: '⋯', label: 'Karar bekliyor' },
    violation: { code: '✕', label: 'Kural ihlali' },
    corrected: { code: '✎', label: 'Düzeltilmiş' },
    workedOnLeave: { code: 'İÇ', label: 'İzinli günde çalışma' },
  },
  live: {
    expected: { label: 'Bekleniyor' },
    inside: { label: 'İçeride' },
    onBreak: { label: 'Molada' },
    late: { label: 'Geç' },
    absent: { label: 'Gelmedi' },
    leftEarly: { label: 'Erken bitirdi' },
    done: { label: 'Mesai bitti' },
    missingCheckout: { label: 'Bitişi eksik' },
    onLeave: { label: 'İzinli' },
    review: { label: 'İncele' },
    rejected: { label: 'Reddedildi' },
  },
  request: {
    pending: { label: 'Bekliyor' },
    approved: { label: 'Onaylandı' },
    rejected: { label: 'Reddedildi' },
    cancelPending: { label: 'İptal bekliyor' },
    cancelled: { label: 'İptal edildi' },
    // S33: İzin 2.0'da talep sahibinin geri çektiği talep (kayıt silinmez).
    withdrawn: { label: 'Geri çekildi' },
    failed: { label: 'Uygulanamadı' },
  },
  // S37-b: telafi borcu (açık ya da iptal) ve telafi işaretli atama.
  makeup: {
    open: { label: 'Açık' },
    cancelled: { label: 'İptal edildi' },
    marked: { label: 'Telafi' },
  },
  period: {
    open: { label: 'Açık' },
    inReview: { label: 'İncelemede' },
    approved: { label: 'Onaylandı' },
    locked: { label: 'Kilitli' },
    exported: { label: 'Aktarıldı' },
  },
  roster: {
    draft: { label: 'Taslak' },
    published: { label: 'Yayınlandı' },
    changedAfterPublish: { label: 'Yayından sonra değişti' },
  },
  plan: {
    engel: { label: 'ENGEL' },
    uyari: { label: 'UYARI' },
    bilgi: { label: 'BİLGİ' },
    isaret: { label: 'İŞARET' },
  },
  display: {
    online: { label: 'Çevrimiçi' },
    delayed: { label: 'Gecikiyor' },
    offline: { label: 'Çevrimdışı' },
    pendingSetup: { label: 'Kurulum bekliyor' },
    unpaired: { label: 'Eşleştirilmedi' },
    revoked: { label: 'İptal edildi' },
  },
  // Çalışanın telefonu, mesai kaydı için (S25).
  device: {
    trusted: { label: 'Güvenilir' },
    pending: { label: 'Onay bekliyor' },
    rejected: { label: 'Reddedildi' },
    removed: { label: 'Kaldırıldı' },
  },
  // Zamanlanmış raporun son gönderimi (S15, F0-C4).
  delivery: {
    sent: { label: 'Gönderildi' },
    failed: { label: 'Gönderilemedi' },
    never: { label: 'Henüz gönderilmedi' },
  },
  // Fazla süre adayı kararı (S20): "Çalışma sayma" ve otomatik sayılan kalem.
  decision: {
    notWork: { label: 'Çalışma sayılmadı' },
    auto: { label: 'Otomatik sayıldı' },
  },
  // Tahmini işçilik maliyeti (S58): kesinleşmemiş ay tutarı.
  cost: {
    provisional: { label: 'Kesinleşmedi' },
  },
  event: {
    CheckIn: 'Mesai başladı',
    CheckOut: 'Mesai bitti',
    BreakStart: 'Molaya çıktı',
    BreakEnd: 'Moladan döndü',
    Correction: 'Düzeltme',
  },
  evidence: {
    Identity: 'Kimlik',
    Location: 'Konum',
    AuthenticatedSession: 'Oturum',
    Geolocation: 'Cihaz konumu',
    Challenge: 'Dinamik kod',
    Freshness: 'Tazelik',
    Device: 'Cihaz',
    UserPresence: 'Kişinin yanında olması',
    Proximity: 'Yakınlık',
    CredentialPossession: 'Kart',
    Passkey: 'Geçiş anahtarı',
    ReaderLocation: 'Okuyucunun yeri',
  },
} as const;
